/**
 * @generated SignedSource<<1155261059de4f7bdfbe586673255e78>>
 * @relayHash 5c7e3adbcb7bcaf4de0f4c1490bc6f3a
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/362.0.0-2022-04-25T22:46:06.901Z/setLangCookieMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetLangCookieInput = {
  locale?: string | null;
  cookieDomain?: string | null;
  clientMutationId?: string | null;
};
export type setLangCookieMutation$variables = {
  input: SetLangCookieInput;
};
export type setLangCookieMutation$data = {
  readonly setLangCookie: {
    readonly clientMutationId: string | null;
  } | null;
};
export type setLangCookieMutation = {
  variables: setLangCookieMutation$variables;
  response: setLangCookieMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetLangCookiePayload",
    "kind": "LinkedField",
    "name": "setLangCookie",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setLangCookieMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setLangCookieMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/362.0.0-2022-04-25T22:46:06.901Z/setLangCookieMutation",
    "metadata": {},
    "name": "setLangCookieMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "fd787194fded1ecfdb78628ca23499b1";

export default node;
